<template>
  <div class="activity-log-list" v-loading="isLoading">
    <div class="activity-log-list__header">
      <div class="title">{{L10n('activity-log')}}</div>
      <div v-if="count > previewCount" class="activity-log-list__btn-wrap-all">
        <button
          type="button"
          class="btn btn-size-s btn-no-border"
          @click="handlerShowViewAll"
        >
          {{L10n('view-all')}}
        </button>
      </div>
      <div>
        <button
          type="button"
          class="btn btn-size-s btn-no-border"
          @click="isVisibleDialog = true"
        >
          <i class="el-icon-plus"></i>
          {{L10n('add')}}
        </button>
      </div>
    </div>
    <div class="activity-log-list__content">
      <activity-item
        v-for="item in previewItemList"
        :key="item.id"
        :data="item"
        :formModel="Model"
      />
    </div>
    <modal-new
      :isVisible.sync="isVisibleDialog"
      :isLoading="isLoading"
      :formModel="Model"
      @onCreate="handlerCreateItem"
    ></modal-new>
    <dialog-info
      v-if="isVisibleModalAll"
      :is-loading="isLoading"
      :title="L10n('activity-log-list')"
      customClass="activity-log-dialog"
      ref="modalAll"
      @close="handlerHideViewAll"
    >
      <activity-item
        v-for="item in data"
        :key="item.id"
        :data="item"
        :formModel="Model"
      />
      <!-- SLOT -->
      <slot name="dialog-info"></slot>
    </dialog-info>
  </div>
</template>

<script>
import { toDate } from '@/utils/filters'
import { createParams } from '@/utils/dynamic'
import { waitValue } from '@/utils/promises'
import { api } from '@/services/api'

export default {
  name: 'ActivityInfoLog',
  components: {
    'activity-item': () => import(/* webpackChunkName: 'Shared' */ './Item'),
    'modal-new': () => import(/* webpackChunkName: 'Shared' */ './ModalNew'),
    'dialog-info': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogInfo')
  },
  props: {
    activityID: { required: true },
    apiGet: { type: String, required: true },
    apiCreate: { type: String, required: true },
    Model: {
      type: Function,
      default: () => ({})
    },
    params: {
      type: Object,
      default: () => ({})
    },
    previewCount: {
      type: Number,
      default: 3
    }
  },
  watch: {
    activityID: {
      immediate: true,
      handler (value) {
        if (value) {
          this.loadList()
        }
      }
    },
    isVisibleModalAll: {
      immediate: true,
      handler (value) {
        if (value) {
          this.loadList()
        }
      }
    }
  },
  beforeDestroy () {
    this.$emit('onUpdateCount', 0)
  },
  data () {
    return {
      isLoading: false,
      isVisibleDialog: false,
      isVisibleModalAll: false,
      data: [],
      count: 0
    }
  },
  computed: {
    previewItemList () {
      return this.data.slice(0, this.previewCount)
    }
  },
  methods: {
    /* USER INTERFACE */
    createItem (data) {
      this.handlerCreateItem(data)
    },
    getData () {
      return this.data
    },
    loadList () {
      if (!this.activityID) {
        return
      }
      this.isLoading = true
      let params = createParams(this.params)
      return api
        .get(this.apiGet, {
          params: {
            ...params,
            take: this.isVisibleModalAll ? undefined : this.previewCount,
            count: true
          }
        })
        .then((response) => {
          this.data = this.parseData(response.data.value)
          this.count = response.data.count

          this.isLoading = false
          this.$emit('onUpdateCount', this.count)
          return this.data
        })
        .catch(err => {
          this.requestErrorHandler(err)
          this.isLoading = false
        })
    },
    /* AND USER INTERFACE */
    handlerShowViewAll () {
      this.isVisibleModalAll = true
      waitValue(() => this.$refs['modalAll'])
        .then((dialog) => {
          dialog.show()
        })
    },
    handlerHideViewAll () {
      this.$nextTick(() => {
        this.isVisibleModalAll = false
      })
    },
    parseData (data) {
      return data
        .map((item) => {
          return {
            ...item,
            entryDate: toDate(item.entryDate, 'DD/MM/YYYY HH:mm')
          }
        })
    },
    handlerCreateItem (data) {
      this.isLoading = true
      let _data = { ...data }
      delete _data['id']
      return api
        .post(`${this.apiCreate}`, _data)
        .then((response) => {
          this.isVisibleDialog = false
          return this.loadList()
        })
        .catch((err) => {
          this.requestErrorHandler(err)
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
<style lang="stylus">
  .dialog-scroll .el-dialog.activity-log-dialog{
    max-width 70rem
  }
  .activity-log-list{
    display flex
    flex-direction column
    .title{
      color grey
      font-weight 500
    }
    .title::first-letter{
      text-transform capitalize
    }
    .sub-title{
      color grey
      font-size .8em
    }
    &__header{
      display flex
    align-items center
    justify-content space-between
    }
    &__btn-wrap-all{
      margin-left auto
      margin-right 1rem
    }
    &__content{
      min-height 5rem
    }
    &__btn-view-more-wrap{
      position relative
      display flex
      align-items center
      justify-content center
      .btn-view-more{
        position absolute;
        z-index 2
        top -1.3rem
      }
    }
  }
</style>
